import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '@/shared/constants/linksApi.js'

export const profileApi = createApi({
    reducerPath: 'profileApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_URL,
        mode: "cors",
        credentials: 'include',
    }),
    endpoints: (builder) => ({
        getProfileInfo: builder.mutation({
            query: () => ({
                url: '/back/profile/profile',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
        }),
        changeProfileInfo: builder.mutation({
            query: (formData) => ({
                url: '/back/profile/save',
                method: 'POST',
                body: formData,
            }),
        }),
        getHistoryOrders: builder.mutation({
            query: (id) => ({
                url: '/back/order/users',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: {
                    customer_id: id,
                },
            }),
        }),
        getFilteredOrders: builder.mutation({
            query: (filters) => ({
                url: '/back/order/filter',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: filters,
            }),
        }),
        getOrderStatuses: builder.mutation({
            query: () => ({
                url: '/back/order/statuses',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
        }),
        // Новый метод для отмены заказа
        cancelOrder: builder.mutation({
            query: (data) => ({
                url: '/back/order/cancel',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: {
                    order_id: data.order_id,
                    customer_id: data.customer_id,
                },
            }),
        }),
        getProductsOrder: builder.mutation({
            query: (id) => ({
                url: '/back/product/orders',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: {
                    order_id: id,
                },
            }),
        }),
        changePassword: builder.mutation({
            query: (body) => ({
                url: '/back/profile/settings',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            }),
        }),
    }),
})